<template>
    <v-app id="inspire">
        <auth></auth>
        <template v-if="isAuthorized">
            <Header v-model="expandOnHover"></Header>
<!--            <Sidebar :expand-on-hover.sync="expandOnHover"></Sidebar>-->
            <v-main>
                <BreadCrumbs></BreadCrumbs>
                <router-view v-if="hasPermissionsToCurrentRoute"/>
            </v-main>
            <Footer></Footer>
        </template>
        <notifications :width="400" />
    </v-app>
</template>

<script>
import Header from "./header/Header";
// import Sidebar from "./sidebar/Sidebar";
import Footer from "./footer/Footer";
import {mapState, mapMutations} from "vuex";
import BreadCrumbs from "@/components/BreadCrumbs/BreadCrumbs.vue";
import Auth from "@/components/commonComponents/Auth.vue";
import UserAuth from "@/mixins/UserAuth";
import HasPermissionsToRoute from "@/mixins/HasPermissionsToRoute";

export default {
    name: "Layout",

    components: {
        Auth,
        BreadCrumbs,
        Header,
        // Sidebar,
        Footer
    },

    mixins: [
        UserAuth,
        HasPermissionsToRoute,
    ],

    props: {
        source: String
    },
    data: () => ({
        expandOnHover: false
    }),
    computed: {
        ...mapState(["Customizer_drawer"]),
        hasPermissionsToCurrentRoute() {
            return this.hasPermissionsToRoute(this.$route);
        },
    },
    watch: {
        isAuthorized: {
            handler(v) {
                if (v) {
                    if (!this.hasPermissionsToCurrentRoute) {
                        this.$router.push({name: 'Error403'});
                    } else if (this.$route.meta?.redirect) {
                        this.$router.replace(this.$route.meta.redirect);
                    }
                }
            },
            immediate: true,
        },
    },
    methods: {
        ...mapMutations({
            setCustomizerDrawer: "SET_CUSTOMIZER_DRAWER"
        })
    },
    mounted() {
    },
    beforeDestroy() {
    },
    beforeRouteUpdate(to, from, next) {
        if (this) {
            if (this.hasPermissionsToRoute(to)) {
                if (to.meta?.redirect) {
                    next(to.meta.redirect);
                } else {
                    next();
                }
            } else {
                next({name: 'Error403'});
            }
        } else {
            next();
        }
    },
};
</script>
<style lang="scss">
</style>